export default "__VITE_ASSET__88c3500d__"